import { HttpErrorResponse } from "@angular/common/http";
import { patchState, signalStore, withHooks, withMethods } from "@ngrx/signals";
import { setAllEntities, setEntity, withEntities } from "@ngrx/signals/entities";
import { setFulfilled, setPending, withRequestStatus } from "../extensions/request-status.feature";
import { inject } from "@angular/core";
import { rxMethod } from "@ngrx/signals/rxjs-interop";
import { pipe, switchMap, tap } from "rxjs";
import { ApiClientsService } from "../../services/api-playcharge.service";
import { ClientViewModel } from "@playcharge/common/models/backend/clients/client-view-model";
import { ClientEditModel } from "@playcharge/common/models/backend/clients/client-edit-model";

export type ClientsStore = InstanceType<typeof ClientsStore>;

export const ClientsStore = signalStore(
    { providedIn: "root" },
    withEntities<ClientViewModel>(),
    withRequestStatus(),
    withMethods((store, apiClientsService = inject(ApiClientsService)) => ({
        loadClients: rxMethod<void>(
            pipe(
                tap(() => patchState(store, setPending())),
                switchMap(() => {
                    return apiClientsService.getClients().pipe(
                        tap((clients) => {
                            patchState(store, setAllEntities(clients));
                            patchState(store, setFulfilled());
                        }),
                    );
                }),
            ),
        ),
        createClient: rxMethod<{
            model: ClientEditModel;
            next?: () => void;
            error?: (error: HttpErrorResponse) => void;
        }>(
            pipe(
                switchMap((request) => {
                    return apiClientsService.createClient(request.model).pipe(
                        tap((clients) => {
                            patchState(store, setEntity(clients));
                            patchState(store, setFulfilled());
                        }),
                    );
                }),
            ),
        ),
        updateClient: rxMethod<{
            model: ClientEditModel;
            next?: () => void;
            error?: (error: HttpErrorResponse) => void;
        }>(
            pipe(
                switchMap((request) => {
                    return apiClientsService.updateClient(request.model).pipe(
                        tap((clients) => {
                            patchState(store, setEntity(clients));
                            patchState(store, setFulfilled());
                        }),
                    );
                }),
            ),
        ),
        deleteClient: rxMethod<{
            model: ClientEditModel;
            next?: () => void;
            error?: (error: HttpErrorResponse) => void;
        }>(
            pipe(
                switchMap((request) => {
                    return apiClientsService.createClient(request.model).pipe(
                        tap((clients) => {
                            patchState(store, setEntity(clients));
                            patchState(store, setFulfilled());
                        }),
                    );
                }),
            ),
        ),
    })),
    withHooks((store) => ({
        onInit: () => {
            store.loadClients();
        },
    })),
);
